import { createAction } from 'redux-act';
import { ISpeaker } from 'modules/reducers';

export const getSpeakerList = createAction<any>('get speaker list');
export const getSpeakerListSuccess = createAction<ISpeaker[]>('get speaker list')
